/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'button/cross': {
    width: 10,
    height: 10,
    viewBox: '0 0 10 10',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M4 5L0 9l1 1 4-4 4 4 1-1-4-4 4-4-1-1-4 4-4-4-1 1 4 4z" _fill="currentColor"/>'
  }
})
